import React from 'react'
import Navbar from '../inc/Navbar'
import { Contactform } from './Contactform'
import ScrollToTop from "react-scroll-to-top";
import Slider from '../inc/Slider';
import About from './About';
import "./Home.css";
import SlideButton from './SlideButton';
import Product from './Product';

function Home() {
  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />
      <br />
      <br />

      <ScrollToTop smooth top="100" color="maroon" />

      <div className="paddyseeds">
        <br />
        <br />
        <div className="album py-2">
          <div className="container">
            <div className="row ">
              <div className="col-md-7">
                <Slider />
              </div>
              <div className="col-md-5">
                <Contactform />
              </div>
            </div>
          </div>
        </div>
      </div>
      <SlideButton/>
       <div className='seeds'>
                <div className="album py-2">
                    <div className="container mt-2">
                        <div className="row">
                            <marquee>
                                <h5 style={{ color: "white" }}><b>Welcome to ABP Seeds Corporatrion, Best Seed Supply in Kolkata</b></h5>
                            </marquee>
                        </div>
                    </div>
                </div>


            </div>
      <div className="album py-1">
        <div className="container">
          <div className="row ">
            <div className="col-md-12 mt-2">
              <h1 className='mb-2 mt-2 justify'>About <b style={{ color: "#3D2219" }}> ABP Seeds Corporation</b></h1>

              <p className='justify'>ABP Seeds Corporation is a trusted name in the agricultural seeds industry, committed to delivering high-quality, high-yield seed varieties to farmers across India. With a strong focus on innovation, sustainability, and farmer success, we specialize in premium mustard seeds that ensure better productivity and superior crop performance.</p>
              <p className='justify'>Why Choose ABP Seeds Corporation?
                Premium quality, certified seeds
                High germination and yield performance
                Focus on research-based seed development
                Suitable for diverse Indian climatic conditions
                Trusted by farmers for consistent results</p>

                 <div className="d-flex justify-content-end align-items-end mb-0">
                                <a href='aboutus'>
                                    <button className='seedsproducts  mt-1'>Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                    </svg></button>
                                </a>
                            </div>
            </div>
            {/* <div className="col-md-6 mt-2">
                <img src={abpseeds} className="card-img-top" alt="abpseeds" />

                </div> */}
          </div>
        </div>
      </div>

   <div className="container">

                    <div className="card-body">
                        <div className='welcometext'>
                            <h1 style={{color:"#06300E"}} className="card-title mb-0"><b>Our Products</b></h1>
                            <div className="col-md-3">
                                <hr style={{ color: "#1D4D93" }} />
                            </div>
                        </div>
                        </div>
                        </div>
<Product/>
  
      <br/>


    </div>
  )
}

export default Home